<template>
  <div class="comp-news">
    <ul :class="'comp-news--' + type" v-if="data && data.length">
      <li v-for="(item, i) in data" :key="i">
        <template v-if="type === 'pic'">
          <router-link :to="item.link" :target="target">
            <div class="img">
              <img @error="imgError" v-if="item.Illustration" :src="item.Illustration" alt="item.text" class="image" />
              <img @error="imgError" v-else src="/static/img/no-img.png" alt="item.text" class="image" />
            </div>
            <span class="title text-over-2">{{ item.Headline }}</span>
            <!-- <h3>{{ item.Headline }}</h3> -->
            <p>{{ item.IssueTime }}</p>
          </router-link>
        </template>
        <template v-else>
          <router-link :to="item.link" :target="target">
            <div class="date" v-if="type === 'calendar'">
              <strong>{{ item.IssueTime | dateTimeFilter("dd") }}</strong>
              <span>{{ item.IssueTime | dateTimeFilter("yyyy-MM") }}</span>
            </div>
            <h3>{{ item.Headline }}</h3>
            <p>{{ item.Summary }}</p>
          </router-link>
        </template>
      </li>
    </ul>
    <div v-else class="g-nodata"></div>
  </div>
</template>

<script>
import { dateTimeFilter } from "_f/index";
export default {
  name: "ic-news",
  props: {
    data: {
      type: Array
    },
    type: {
      type: String,
      default: "text"
    },
    target: {
      type: String,
      default: "_self"
    }
  },
  filters: {
    dateTimeFilter
  },
  created() {
    // console.log('type', this.type)
  }
};
</script>

<style lang="scss" scoped>
.comp-news {
  display: flex;
  justify-content: space-between;
  > ul {
    width: 100%;
  }
  li {
    padding: 16px 0;
    height: 33px;
    border-bottom: 1px solid #eeeeee;
    a {
      &:hover {
        h3 {
          color: $primary-color;
        }
        p {
          color: #333333;
        }
      }
    }
    h3 {
      color: rgba(51, 51, 51, 1);
      padding-top: 2px;
      line-height: 14px;
      font-weight: 500;
      font-size: 14px;
      padding-bottom: 6px;
      @include ellipsis();
    }
    p {
      font-size: 12px;
      color: #999;
      line-height: 12px;
      @include ellipsis();
    }
    h3,
    p {
      max-width: 100%;
    }
  }
  &--text {
    li {
      padding-left: 10px;
      position: relative;
      a {
        &::before {
          background-color: #999;
          width: 4px;
          height: 4px;
          display: inline-block;
          content: ' ';
          position: absolute;
          left: 0;
          top: 21px;
        }
        &:hover {
          &::before {
            background-color: $primary-color;
          }
        }
      }
    }
  }
  &--calendar {
    li {
      padding-left: 77px;
      position: relative;
      a {
        .date {
          width: 67px;
          height: 60px;
          background: rgba(236, 240, 255, 1);
          border-radius: 4px;
          display: inline-block;
          content: ' ';
          position: absolute;
          left: 0;
          top: 6px;
          text-align: center;
          strong {
            font-size: 30px;
            color: $primary-color;
            line-height: 32px;
            display: block;
            font-weight: 500;
            margin-top: 8px;
            margin-bottom: 2px;
          }
          span {
            font-size: 10px;
            color: rgba(153, 153, 153, 1);
            line-height: 10px;
            display: block;
          }
        }
        &:hover {
          .date {
            background-color: $primary-color;
            color: #fff;
            strong,
            span {
              color: #fff;
            }
          }
        }
      }
    }
  }
  &--pic {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 376px;
      padding: 0 24px 30px 0;
      border-bottom: none;
      .image {
        width: 376px;
        height: 266px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
      }
      .title {
        font-size: 20px;
        line-height: 28px;
        margin: 10px 0 7px 0;
      }
      p {
        font-size: 16px;
        color: rgba(153, 153, 153, 1);
        line-height: 18px;
      }
      &:nth-child(3n) {
        padding-right: 0;
      }
    }
  }
}
</style>
